var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62Z",
    fill: "#E4F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1617_97430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0972 20.0051C31.4368 19.9576 29.7838 20.2437 28.2359 20.8464C26.688 21.4491 25.2768 22.3562 24.0856 23.5139C22.8945 24.6716 21.9476 26.0564 21.3011 27.5865C20.6546 29.1166 20.3215 30.7608 20.3217 32.4219H17.8521C17.2313 32.4219 16.9277 33.1669 17.3692 33.5946L21.2184 37.4576C21.4944 37.7335 21.9221 37.7335 22.198 37.4576L26.0472 33.5946C26.4887 33.1669 26.1714 32.4219 25.5643 32.4219H23.081C23.081 27.0413 27.4682 22.6954 32.8765 22.7644C38.0088 22.8333 42.3271 27.1516 42.396 32.2839C42.465 37.6784 38.1191 42.0794 32.7385 42.0794C30.5173 42.0794 28.4616 41.3206 26.8336 40.0376C26.5694 39.8294 26.2378 39.7256 25.902 39.746C25.5662 39.7663 25.2497 39.9094 25.0125 40.1479C24.433 40.7412 24.4744 41.7069 25.1228 42.2174C27.2961 43.9196 29.978 44.8427 32.7385 44.8387C39.7057 44.8387 45.3485 39.0856 45.1553 32.0632C44.976 25.5926 39.5678 20.1844 33.0972 20.0051ZM32.3936 26.9033C31.8279 26.9033 31.3589 27.3724 31.3589 27.938V33.0151C31.3589 33.498 31.621 33.9533 32.0349 34.2016L36.3394 36.754C36.8361 37.0437 37.4707 36.8782 37.7604 36.3953C38.0501 35.8986 37.8846 35.264 37.4017 34.9742L33.4283 32.615V27.9242C33.4283 27.3724 32.973 26.9033 32.3936 26.9033Z",
    fill: "#43BAF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1617_97430",
    x: 1.91707,
    y: 4.75691,
    width: 61.8735,
    height: 58.7124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.69368,
    dy: 1.69368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.46838
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1617_97430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1617_97430",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restoreIcon.a06964df4096ae4022595fba1d3ab048.svg";
export { ForwardRef as ReactComponent };